__webpack_require__.p = "https://static.flicknovelcdn.com/reader-website-static/prod_4830894_91_2a93c651/_next/";